

































import Component from "vue-class-component";
import { BaseRootPageComponent } from "@/components/BaseRootPageComponent";

import CoreAPI from "@/utils/core-api";

@Component
export default class About extends BaseRootPageComponent {
  buildVersion = "-";
  buildDate = "-";
  error = "";

  get showEditServer() {
    return this.$nativeApp.isMobile;
  }

  async created() {
    this.setTitle("About");
    await this.fetchInfo();
  }

  async fetchInfo() {
    try {
      const info = await CoreAPI.getBuildInfo();
      this.buildVersion = info.version;
      this.buildDate = info.buildDate;
    } catch (error) {
      this.error = "Failed to load build information. Please check your connectivity and try again.";
      console.error("Cannot get build info from the VVS API", error);
    }
  }

  navigateToEditServer() {
    this.$nativeApp.navigateToEditServer();
  }
}
